"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettifyOutput = exports.solidityVersion = exports.license = exports.name = void 0;
exports.name = "MyInterface";
exports.license = "UNLICENSED";
exports.solidityVersion = ">=0.7.0 <0.9.0";
exports.prettifyOutput = true;
//# sourceMappingURL=defaults.js.map